import React from 'react';
import SearchBar from './SearchBar';
import LanguageSelector, { LanguageCode } from './LanguageSelector';
import CurrencySelector, { CurrencyCode } from './CurrencySelector';

interface HeaderProps {
  balance: number;
  onRefreshBalance: () => void;
  onLogout: () => void;
  loading: boolean;
  searchTerm: string;
  onSearchChange: (term: string) => void;
  selectedLanguage: LanguageCode;
  onLanguageChange: (language: LanguageCode) => void;
  selectedCurrency: CurrencyCode;
  onCurrencyChange: (currency: CurrencyCode) => void;
  isAdmin?: boolean;
  onShowStats?: () => void;
  onShowCreateGame?: () => void;
}

const Header: React.FC<HeaderProps> = ({ balance, onRefreshBalance, onLogout, loading, searchTerm, onSearchChange, selectedLanguage, onLanguageChange, selectedCurrency, onCurrencyChange, isAdmin, onShowStats, onShowCreateGame }) => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-actions left">
          <div className="balance-section">
            <span className="balance-label">Balance:</span>
            <span className="balance-amount">${balance.toFixed(2)}</span>
            <button
              className="btn btn-refresh"
              onClick={onRefreshBalance}
              disabled={loading}
            >
              🔄
            </button>
          </div>
          {isAdmin && (
            <>
              <span className="admin-badge" style={{ marginLeft: '10px', padding: '4px 8px', backgroundColor: '#ff6b6b', color: 'white', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold' }}>
                ADMIN
              </span>
              {onShowStats && (
                <button
                  className="btn btn-stats"
                  onClick={onShowStats}
                  disabled={loading}
                  style={{ marginLeft: '10px', padding: '6px 12px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                >
                  📊 Statistics
                </button>
              )}
              {onShowCreateGame && (
                <button
                  className="btn btn-create-game"
                  onClick={onShowCreateGame}
                  disabled={loading}
                  style={{ marginLeft: '10px', padding: '6px 12px', backgroundColor: '#2196F3', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                >
                  ➕ Create Game
                </button>
              )}
            </>
          )}
          <button
            className="btn btn-logout"
            onClick={onLogout}
            disabled={loading}
          >
            Logout
          </button>
        </div>

        <div className="header-center">
          <div className="header-search">
            <SearchBar
              searchTerm={searchTerm}
              onSearchChange={onSearchChange}
              placeholder="Search games..."
            />
          </div>
          <LanguageSelector
            selectedLanguage={selectedLanguage}
            onLanguageChange={onLanguageChange}
          />
          <CurrencySelector
            selectedCurrency={selectedCurrency}
            onCurrencyChange={onCurrencyChange}
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
